import { createSlice } from "@reduxjs/toolkit";

class toastProps {
	key: number = 0;
	open: boolean = false;
	duration?: number = 6000;
	messages: string[] = [];
}

const initialState: {
	toasts: toastProps[];
	count: number;
} = {
	toasts: [],
	count: 1,
};

const toastSlice = createSlice({
	name: "toastSlice",
	initialState,
	reducers: {
		showToast: (
			state,
			action: {
				type: string;
				payload: {
					value: string[];
				};
			}
		) => {
			if (action.payload.value) {
				let temp = [...state.toasts];
				temp.push({
					key: state.count,
					open: true,
					duration: 6000,
					messages: action.payload.value,
				});
				state.count += 1;
				state.toasts = temp;
			}
		},
		hideToast: (state, action) => {
			const match = state.toasts.findIndex((i) => i.key === action.payload.value);
			let temp = [...state.toasts];
			if (match >= -1) {
				temp.splice(match, 1);
			} else {
				console.log(action.payload.value);
			}
			state.toasts = temp;
		},
	},
});

export const { showToast, hideToast } = toastSlice.actions;

export default toastSlice.reducer;
